"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _Autocomplete = _interopRequireDefault(require("../Autocomplete"));

require("./categoryAutocomplete.scss");

var _excluded = ["nextHttpClient", "categoryAutocompleteDetails"];

var getSuggestionsUrlDefault = function getSuggestionsUrlDefault(query) {
  return "/gateway/service-provider/v1/categories?query=".concat(query.toLowerCase(), "&size=5");
};

var parseOneSectionSuggestionsResponse = function parseOneSectionSuggestionsResponse(response) {
  return (0, _get2.default)(response, 'body.categories', []);
};

var CategoryAutocomplete = function CategoryAutocomplete(_ref) {
  var nextHttpClient = _ref.nextHttpClient,
      categoryAutocompleteDetails = _ref.categoryAutocompleteDetails,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var getSuggestionsUrl = categoryAutocompleteDetails.getSuggestionsUrl || getSuggestionsUrlDefault;
  var parseSuggestionsResponse = categoryAutocompleteDetails.parseSuggestionsResponse || parseOneSectionSuggestionsResponse;
  return /*#__PURE__*/(0, _jsx2.default)("div", {
    className: "form-group"
  }, void 0, /*#__PURE__*/(0, _jsx2.default)("label", {
    htmlFor: categoryAutocompleteDetails.id,
    className: "control-label"
  }, "label", /*#__PURE__*/(0, _jsx2.default)("span", {
    className: "input-label-text"
  }, void 0, categoryAutocompleteDetails.label)), /*#__PURE__*/(0, _jsx2.default)(_Autocomplete.default, {
    nextHttpClient: nextHttpClient,
    otherProps: otherProps,
    id: categoryAutocompleteDetails.id,
    placeholder: categoryAutocompleteDetails.placeholder,
    autoFocus: categoryAutocompleteDetails.autoFocus,
    getSuggestionsUrl: getSuggestionsUrl,
    multiSection: false,
    iconLocation: categoryAutocompleteDetails.iconLocation,
    parseSuggestionsResponse: parseSuggestionsResponse,
    onSubmit: categoryAutocompleteDetails.autocompleteEventHandler,
    requireSelection: categoryAutocompleteDetails.requireSelection,
    clearAfterSelection: categoryAutocompleteDetails.clearAfterSelection
  }));
};

CategoryAutocomplete.defaultProps = {
  categoryAutocompleteDetails: {
    id: 'category-autocomplete',
    placeholder: 'Start typing and select a category',
    autoFocus: true,
    iconLocation: 'none',
    requireSelection: true,
    clearAfterSelection: false,
    label: 'Service Performed',
    autocompleteEventHandler: function autocompleteEventHandler() {},
    getSuggestionsUrl: getSuggestionsUrlDefault,
    parseSuggestionsResponse: parseOneSectionSuggestionsResponse
  }
};

var _default = (0, _compose.default)(_pure.default)(CategoryAutocomplete);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/autocomplete/categoryAutocomplete/CategoryAutocomplete.js
// module id = 1046
// module chunks = 25